<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        :table-action="false"
        :table-select="false"
        module="basic"
        method="postJson"
        url="productionOrderScheduled/workshop"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="排产日期">
              <el-date-picker
                  v-model="filter.planDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width:160px"
                  clearable/>
            </el-form-item>
            <el-form-item label="排产产线">
              <el-select v-model="filter.productionLine" style="width:140px" clearable>
                <el-option
                    v-for="item in lineList"
                    :key="item.lineName"
                    :label="item.lineName"
                    :value="item.lineName"/>
              </el-select>
            </el-form-item>
            <el-form-item label="工序类型">
              <el-select v-model="filter.productionLineType" clearable placeholder="全部" style="width:120px">
                <el-option label="组装" :value="1"/>
                <el-option label="测试" :value="2"/>
                <el-option label="发料" :value="3"/>
                <el-option label="包装" :value="4"/>
                <el-option label="发货前处理" :value="5"/>
              </el-select>
            </el-form-item>
            <el-form-item label="班次">
              <el-select v-model="filter.shift" clearable>
                <el-option label="白班" value="白班"/>
                <el-option label="夜班" value="夜班"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "ProductionOrderScheduleQueryList",
    components: { ViewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: false,
          delAuth: false,
        },
        scheduledPerson: "",
        lineList: [],
        filter: {
          orders: "",
          materialNo: "",
          materialDescription: "",
          orderType: "",
          productStartDate: "",
          productEndDate: "",
          assemblePlan: "",
          testPlan: "",
          feedPlan: "",
          fhqPlan: "",
          planDate: "",
          productionLine: "",
        },
        columnsProperty: [
          { tooltip: true, key: "planDate", align: "center", width: 110 },
          { tooltip: true, key: "productionLine", align: "center", width: 100 },
          { tooltip: true, key: "productionOrderNo", align: "center", width: 110 },
          { tooltip: true, key: "scheduledQty", label: "排产数量", align: "center", width: 80 },
          { tooltip: true, key: "workTime", label: "工时", align: "center", width: 70 },
          { tooltip: true, key: "quantity", label: "工单数量", align: "center", width: 80 },
          { tooltip: true, key: "materialNo", align: "center", width: 130 },
          { tooltip: true, key: "orderTypeName", label: "工单类型", align: "center", width: 100 },
          { tooltip: true, key: "specification", label: "规格型号", align: "center", width: 100 },
          { tooltip: true, key: "productLayer", label: "产品层次", align: "center", width: 100 },
          { tooltip: true, key: "addDate", label: "下单日期", align: "center", width: 160 },
        ],
      };
    },

    mounted() {
      this.loadLineList();
    },
    methods: {
      // 加载产线下拉列表（从 MES_ProductionLine 取值）
      loadLineList() {
        this.$http.get("basic", "fm/production-mangeline/list").then(res => {
          if (res.success) {
            this.lineList = res.data || [];
          }
        });
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange] && this[timeRange].length === 2) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
